import { Asset, type Application } from 'playcanvas';
interface Entry { asset: Asset; ready: Promise<Asset>; refs: number; settled: boolean; owned: boolean }
const caches = new WeakMap<Application, Map<string, Entry>>();
/** A GLB container is shared; model entities and animation controllers are per player. */
export function acquireAvatar(app: Application, url: string) {
    let cache = caches.get(app);
    if (!cache) { cache = new Map(); caches.set(app, cache); }
    let entry = cache.get(url);
    const cleanup = (e: Entry) => {
        if (e.refs || !e.settled || cache!.get(url) !== e) return;
        cache!.delete(url);
        if (e.owned) { e.asset.unload(); app.assets.remove(e.asset); }
    };
    if (!entry) {
        const existing = app.assets.getByUrl(url), asset = existing ?? new Asset(url, 'container', { url });
        entry = { asset, refs: 0, settled: false, owned: !existing, ready: Promise.resolve(asset) };
        const e = entry;
        e.ready = new Promise<Asset>((resolve, reject) => {
            if (asset.loaded) { resolve(asset); return; }
            const off = () => { asset.off('load', loaded); asset.off('error', failed); };
            const loaded = () => { off(); resolve(asset); };
            const failed = (error: unknown) => { off(); reject(new Error(String(error))); };
            asset.once('load', loaded); asset.once('error', failed);
            if (!existing) app.assets.add(asset);
            app.assets.load(asset);
        }).finally(() => { e.settled = true; queueMicrotask(() => cleanup(e)); });
        cache.set(url, e);
    }
    entry.refs++;
    const e = entry; let released = false;
    return { ready: e.ready, release: () => { if (!released) { released = true; e.refs--; cleanup(e); } } };
}
